import Text from '../../../../atoms/Text';

interface ITickersModalTabprops {
  name: string;
  className: string;
  onClick: () => void;
}

const TickersModalTab = ({
  name,
  className,
  onClick,
}: ITickersModalTabprops) => {
  const tab_names = name.split(' ');
  return (
    <div className={className} onClick={onClick}>
      {tab_names.map((i) => (
        <div key={i} className='tabs_container__tabs__item_name'>
          <Text size={14}>{i}</Text>
        </div>
      ))}
    </div>
  );
};

export default TickersModalTab;
